// extracted by mini-css-extract-plugin
export default {"gray02":"#D8DDE1","ZccAdd":"ZccAddLight__ZccAdd___Jo-es","addButton":"ZccAddLight__addButton___WaVxn","form":"ZccAddLight__form___cbnY5"};